module.exports = __webpack_public_path__ + "static/img/PM.fc64d192.svg";